
// INCLUDE YOUR CUSTOM UTILITIES HERE
export function getModelName() {
    return 'Reminders'
}
